export default "__VITE_ASSET__CxwsGAY6__"